<script>
export default {
  name: 'News',
  data () {
    return {
      msg: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/News/NewsIndex.vue